const Cart = (props: React.HTMLAttributes<SVGElement>): JSX.Element => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="30"
    viewBox="0 0 31 30"
    fill="none"
  >
    <mask id="mask0_6294_3931" maskUnits="userSpaceOnUse" x="0" y="0" width="31" height="30">
      <rect x="0.429443" width="30" height="30" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_6294_3931)">
      <path
        d="M9.54793 27.7778C8.81391 27.7778 8.18556 27.5276 7.66285 27.0271C7.14015 26.5266 6.87879 25.925 6.87879 25.2222C6.87879 24.5195 7.14015 23.9178 7.66285 23.4174C8.18556 22.9169 8.81391 22.6667 9.54793 22.6667C10.2819 22.6667 10.9103 22.9169 11.433 23.4174C11.9557 23.9178 12.2171 24.5195 12.2171 25.2222C12.2171 25.925 11.9557 26.5266 11.433 27.0271C10.9103 27.5276 10.2819 27.7778 9.54793 27.7778ZM22.8936 27.7778C22.1596 27.7778 21.5312 27.5276 21.0085 27.0271C20.4858 26.5266 20.2245 25.925 20.2245 25.2222C20.2245 24.5195 20.4858 23.9178 21.0085 23.4174C21.5312 22.9169 22.1596 22.6667 22.8936 22.6667C23.6276 22.6667 24.256 22.9169 24.7787 23.4174C25.3014 23.9178 25.5627 24.5195 25.5627 25.2222C25.5627 25.925 25.3014 26.5266 24.7787 27.0271C24.256 27.5276 23.6276 27.7778 22.8936 27.7778ZM7.14571 4.77778H26.8306C27.3421 4.77778 27.7314 4.99607 27.9983 5.43265C28.2652 5.86922 28.2763 6.31112 28.0317 6.75834L23.294 14.9361C23.0493 15.362 22.7212 15.6921 22.3097 15.9264C21.8982 16.1607 21.4478 16.2778 20.9585 16.2778H11.0159L9.54793 18.8333H25.5627V21.3889H9.54793C8.547 21.3889 7.79075 20.9683 7.27916 20.1271C6.76758 19.2859 6.74534 18.45 7.21243 17.6195L9.0141 14.4889L4.20966 4.77778H1.54053V2.22223H5.87787L7.14571 4.77778Z"
        fill="#00355E"
      />
    </g>
  </svg>
);
export default Cart;
